// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__bXWWH"};